import { parseISO } from 'date-fns'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { PropertyResponse } from '@/types/Property'
import { formatDate } from '@/util'

type Props = {
  property: PropertyResponse
}

const MobilePropertyCard = ({ property }: Props) => {
  const createdOn = property?.createdAt ? formatDate(parseISO(property.createdAt), 'MM/dd/yyyy') : '-'
  const navigate = useNavigate()

  function routeToProperty(propertyId?: number) {
    if (propertyId) {
      navigate(`/properties/${propertyId}`)
    }
  }

  return (
    <div
      className="mb-4 w-full overflow-hidden rounded-md border border-border-primary p-4 shadow-md"
      onClick={() => routeToProperty(property.id)}
      role={'presentation'}
    >
      <div className="mb-3 flex items-center justify-between">
        <p className="text-sm" style={{ fontWeight: 'bold' }}>
          {property?.name || ' '} · {property?.id}
        </p>
      </div>
      <div className="mb-2 flex justify-between">
        <p className="flex-none text-sm text-grey-500">Management Company</p>
        <p className="ml-3 flex-1 text-right text-sm">{property.managementCompany?.name}</p>
      </div>
      <div className="mb-2 flex justify-between">
        <p className="flex-none text-sm text-grey-500">Created On </p>
        <p className="ml-3 flex-1 text-right text-sm">{createdOn}</p>
      </div>
    </div>
  )
}
export default MobilePropertyCard
